import React from "react";
import "../rapidFire/StartRapidHeader.css";
import JoinBattleCode from "./JoinBattleCode";
import "./StartGamification.css";
import heroImg from "../../assets/images/qb1.png";

const StartGamificationHeader = ({
  title = "Gamification",
  description = "Compete, Learn & Improve Daily",
  rank = 0,
  coins = 0,
  score = 0,
  onStartBattle,
  onCoinsClick,
  onLeaderboardClick,
}) => {
  return (
    <div className="qb-body">
      <div className="d-flex align-items-center justify-content-center">
        <div className="rapid-fire-card">
          <div className="rapid-fire-header">
            <h1 className="qb-title">{title}</h1>
          </div>

          <p className="game-description">{description}</p>

          <div className="game-battle-stats-container">
            <button className="game-stat-btn" type="button" onClick={onLeaderboardClick}>
              <span className="game-stat-icon">T</span>
              <span>{`${rank} Rank`}</span>
            </button>

            <button className="game-stat-btn" type="button" onClick={onCoinsClick}>
              <span className="game-stat-icon coin">C</span>
              <span>{`${coins} Coins`}</span>
            </button>

            <button className="game-stat-btn" type="button" onClick={onLeaderboardClick}>
              <span className="game-stat-icon score">S</span>
              <span>{`${score} Score`}</span>
            </button>

            <button
              className="game-start-battle-btn"
              type="button"
              onClick={onStartBattle}
            >
              Start Battle
            </button>
          </div>

          <JoinBattleCode />
        </div>

        <div className="qb-visual gamification-visual" aria-hidden="true">
          <div className="qb-dots">
            {Array.from({ length: 21 }).map((_, index) => (
              <span key={index} />
            ))}
          </div>

          <img src={heroImg} alt="" className="qb-hero" />
        </div>
      </div>
    </div>
  );
};

export default StartGamificationHeader;
